/* ============================================================
   D3X TRANSPARENCY PAGE — JS
   ============================================================ */

(function () {
  function setupReveal() {
    var root = document.querySelector('.d3x-root');
    if (!root || !('IntersectionObserver' in window)) return;
    root.classList.add('js-reveal');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08 });
    root.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
    setTimeout(function () {
      root.querySelectorAll('.reveal:not(.in)').forEach(function(el) { el.classList.add('in'); });
    }, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupReveal);
  } else {
    setupReveal();
  }
})();
